import React__default from 'react';

var PlayForRealButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React__default.createElement("button", { className: 'play-real-btn', onClick: onClick, title: text },
        React__default.createElement("span", { className: 'play-real-btn-txt' }, text)));
};

export { PlayForRealButton };
